import { BaseService } from "./../base";
export class NodeService extends BaseService {
  static get entity() {
    return "node";
  }
  static get name() {
    return "node";
  }

  static async getByNodetype(node_type_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_type/${node_type_id}`, this.name);
  }

  static async getByAllNodes() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }
}
